module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/service-image--pc-e87cfa259b072f3d74f077aca0c79b15.png";